module.exports = __webpack_public_path__ + "img/home_img_vr.312009e6.png";